module.exports = __webpack_public_path__ + "img/2.4e114325.png";